import { Anchor, Group, Sx, useMantineTheme } from "@mantine/core";

const NAVBAR_LINKS = [
  {
    title: "Registry",
    link: "/r",
  },
  {
    title: "Playground",
    link: "/playground/new",
  },
  {
    title: "App",
    link: "/products/semgrep-app",
  },
  {
    title: "Pricing",
    link: "/pricing",
  },
  {
    title: "Resources",
    link: "https://semgrep.dev/docs",
  },
];

export const MarketingNavbar = () => {
  const theme = useMantineTheme();

  const groupStyles: Sx = {
    height: 80,
    background: "white",
    padding: "0 40px 0 120px",
    boxShadow:
      "rgb(54 106 155 / 10%) 0px 4px 8px -2px, rgb(54 106 155 / 6%) 0px 2px 4px -2px",
    position: "relative",
  };

  // making the styles look like the marketing page
  const linkStyles: Sx = {
    color: theme.colors["dark"][3],
    fontWeight: 500,
    "&:hover": {
      color: theme.colors["dark"][6],
      textDecoration: "none",
    },
  };

  return (
    <Group spacing={32} sx={groupStyles}>
      {NAVBAR_LINKS.map(({ title, link }, idx) => (
        <Anchor key={idx} href={link} sx={linkStyles}>
          {title}
        </Anchor>
      ))}
    </Group>
  );
};
